import { SvgIcon, SvgIconProps } from '@mui/material';

const ArrowUpSvgIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6933 22.9072C24.0838 23.2978 24.717 23.2978 25.1075 22.9072C25.498 22.5167 25.498 21.8836 25.1075 21.493L20.9075 17.293C20.8587 17.2442 20.8061 17.2015 20.7506 17.1649C20.3625 16.9086 19.835 16.9513 19.4933 17.293L15.2933 21.493C14.9028 21.8836 14.9028 22.5167 15.2933 22.9072C15.6838 23.2978 16.317 23.2978 16.7075 22.9072L20.2004 19.4143L23.6933 22.9072Z"
        fill="#606060"
      />
    </SvgIcon>
  );
};

export default ArrowUpSvgIcon;
